import { ICountryAndDialCode } from '@aqx-core/common/api/account';

export const getCountryLabelFromSelectedCountry = (country?: Omit<ICountryAndDialCode, 'dialCode'>) => {
  if (!country) {
    return '';
  }

  const countryName = country.country;
  const countryCode = country.countryCode?.toUpperCase();

  return countryCode ? `${countryName} - ${countryCode}` : countryName;
};
